import React, { useState } from 'react'
import styled from 'styled-components'
import Loader from './Loader'
import { motion, AnimatePresence } from 'framer-motion'

export default function LazyImage ({ src, width, height, ...rest }) {
  const [ready, setReady] = useState(false)

  return (
   <Container {...rest}>
     <Image show={ready} onLoad={() => setReady(true)} src={src} customWidth={width} customHeight={height} {...rest}/>
     <AnimatePresence>
       {!ready && (
         <LoaderContainer {...rest} exit={{ opacity: 0 }}>
           <Loader width={width} height={height} {...rest}/>
         </LoaderContainer>
       )}
     </AnimatePresence>
   </Container>
  )
}

const Container = styled.div`
  position: relative;
  display: flex;
`

const Image = styled.img`
  opacity: ${props => props.show ? 1 : 0};
  transition: all .3s ease-in-out;
  width: ${props => props.customWidth};
  height: ${props => props.customHeight};
`

const LoaderContainer = styled(motion.div)`
  position: absolute;
  top:0;
  left: 0;
`

LazyImage.defaultProps = {
  width: 100,
  height: 100,
}